import React, { useEffect, useState } from "react";

import InfoBox from "common-ui-components/components/info-box/InfoBox";
import Table from "common-ui-components/components/table/Table";
import API from "common-ui-components/components/utils/API";
import { useDispatch } from "react-redux";
import { setDeviceId, setSoftwareId } from "../../../reducers/idSlice";
import { Link, useNavigate } from "react-router-dom";
import {
  redirectToDeviceOverview,
  redirectToSoftwareOverview,
} from "app/common/redirects/Redirects";
import { Failure } from "common-ui-components/components/notification/templates";
import { notify } from "common-ui-components/components/notification/Notification";
import arrowRightTop from "../../../app/settings/base/icons/arrowRightTop.svg";
import InfoBoxRedirectButton from "app/common/InfoBoxRedirectButton";
import StatusPill from "common-ui-components/components/pill-cutout/StatusPill";

const UNMANAGED_STATUS_CONFIG = { textColor: "#92650a", bgColor: "#fdedc9" };

const RecentlyInstalledSummary = () => {
  // const [deviceId, setDeviceId] = useState(0);
  // const [softwareId, setSoftwareId] = useState(0);
  const navigate = useNavigate();
  const [recentlyInstalledSummary, setRecentlyInstalledSummary] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getRecentlyInstalledSummary = async () => {
      try {
        setLoading(true);
        const response = await API.get(
          "/inventory/getRecentlyInstalledSoftware",
        );
        //console.log(response.body.result)
        if (response.status.success)
          setRecentlyInstalledSummary(response.body.result);
        else notify(<Failure>Error in fetching summary</Failure>);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    getRecentlyInstalledSummary();
  }, []);
  const NavToApp = ({ record, children }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleClick = (e) => {
      e.preventDefault();
      dispatch(setSoftwareId(record.softwareId));
      redirectToSoftwareOverview(navigate);
    };

    return (
      <Link to="#" onClick={handleClick}>
        {children}
      </Link>
    );
  };

  const ManagedDevice = ({ record, children }) => {
    const rid = record?.deviceId;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    if (rid == null) {
      const rawName =
        typeof children === "string" ? children : record?.installedDevice;
      const deviceName = String(rawName ?? "")
        .replace(/\s*\(unmanaged\)\s*$/i, "")
        .trim();

      return (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "0.5rem",
          }}
        >
          {deviceName}
          <StatusPill statusConfig={UNMANAGED_STATUS_CONFIG}>
            Unmanaged
          </StatusPill>
        </span>
      );
    }

    const handleClick = (e) => {
      e.preventDefault();
      dispatch(setDeviceId(rid));
      redirectToDeviceOverview(navigate);
    };

    return (
      <span
        style={{ cursor: "pointer", color: "#4183c4" }}
        onClick={handleClick}
      >
        {children}
      </span>
    );
  };

  const columns = [
    {
      title: "Software Name",
      accessor: "softwareName",
      WrapperComponent: NavToApp,
    },
    {
      title: "License Type",
      accessor: "softwareType",
      formatFunction: (value) => {
        const LicenseTypeMap = {
          NOT_ASSIGNED: "Not Assigned",
          COMMERCIAL: "Commercial",
          NON_COMMERCIAL: "Non Commercial",
        };
        return LicenseTypeMap[value] || value;
      },
    },
    {
      title: "Installed Date",
      accessor: "installedDate",
    },
    {
      title: "Installed Device",
      accessor: "installedDevice",
      WrapperComponent: ManagedDevice,
    },
  ];

  const records = loading ? [] : recentlyInstalledSummary;
  return (
    <InfoBox
      header={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "0.5rem",
          }}
        >
          Recently Installed Software (Last 10)
          <div
            onClick={() => {
              navigate("/app/inventory/apps");
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              cursor: "pointer",
            }}
          >
            <InfoBoxRedirectButton />
          </div>
        </div>
      }
    >
      <Table
        columns={columns}
        records={records}
        total={loading ? null : records.length}
        skeletonRowCount={7}
      />
    </InfoBox>
  );
};

export default RecentlyInstalledSummary;
